// removed by extract-text-webpack-plugin
module.exports = {"Container":"dropdownmenu__Container__3nmqM","DropdownContent":"dropdownmenu__DropdownContent__2Y_t_","DropdownItem":"dropdownmenu__DropdownItem__1Uy0r","showDropdown":"dropdownmenu__showDropdown__1BE5M"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Monitoring/dropdownmenu.css
// module id = 1656
// module chunks = 2